import { Grid, H3, usePageWidth } from '@fs/zion-ui'
import React from 'react'
import { SourceRail } from '@fs/zion-source-list'
import { useTranslation } from 'react-i18next'
import { useAtPageContentSize } from '../PageContentWidthContext'
import FamilyMembersCardSkeleton from '../cards/family-members-card/FamilyMembersCardSkeleton'
import OtherInformationCardSkeleton from '../cards/other-information-card/OtherInformationCardSkeleton'
import OtherRelationshipsCardSkeleton from '../cards/other-relationships-card/OtherRelationshipsCardSkeleton'
import VitalsCardSkeleton from '../cards/vitals-card/VitalsCardSkeleton'
import { SOURCE_CENTRIC_SECTION_IDS, type VisibleSectionId } from './sourceCentricDetailsTabHelpers'

export default function SourceCentricDetailsTabSkeleton(): JSX.Element {
  const [t] = useTranslation()
  const pageWidth = usePageWidth()
  const atWidth = useAtPageContentSize()
  const showSecondaryCards = pageWidth({ default: false, lg: true })
  const moveSecondaryCards = atWidth({ default: showSecondaryCards, lg: false })
  const gridGutters = 'sm'

  const secondaryCardsColumns = (() => {
    if (moveSecondaryCards) return 12
    if (showSecondaryCards) return 4
    return 'hide'
  })()
  const primaryCardsColumns = moveSecondaryCards || !showSecondaryCards ? 12 : 8

  const sectionOrder: VisibleSectionId[] = [...SOURCE_CENTRIC_SECTION_IDS]

  const sectionSkeletonMap = {
    vitals: <VitalsCardSkeleton key="vitals" totalColumns={primaryCardsColumns} isSingleCardPage={false} />,
    'other-information': (
      <OtherInformationCardSkeleton
        key="other-information"
        totalColumns={primaryCardsColumns}
        isSingleCardPage={false}
      />
    ),
    'family-members': (
      <FamilyMembersCardSkeleton key="family-members" totalColumns={primaryCardsColumns} isSingleCardPage={false} />
    ),
    'other-relationships': (
      <OtherRelationshipsCardSkeleton
        key="other-relationships"
        totalColumns={primaryCardsColumns}
        isSingleCardPage={false}
      />
    ),
  } satisfies Record<VisibleSectionId, JSX.Element>

  return (
    <Grid gutters="nano">
      <Grid gutters={gridGutters}>
        <Grid gutters={gridGutters} columns={primaryCardsColumns} data-testid="left-column">
          {sectionOrder.map((sectionId) => sectionSkeletonMap[sectionId]).filter(Boolean)}
        </Grid>

        <Grid gutters="xs" columns={secondaryCardsColumns} data-testid="right-column">
          <H3 size="H5">{t('tree-person.sources.header')}</H3>
          <SourceRail loading />
        </Grid>
      </Grid>
    </Grid>
  )
}
